import { WaterlilyClient, createQueryKeys } from '@/api/waterlily';

export const rateActionKeys = createQueryKeys('rateAction');

export interface RateActionPresignedUrlResponse {
  url: string;
  bucket: string;
  key: string;
}

export interface RateActionExtractResponse {
  requestId: string;
  status: 'processing' | 'completed' | 'error' | 'applied';
  letterTemplate: string;
  fundingSourceId?: string;
  results?: string;
  error?: string;
  responseDateTime?: string;
  appliedFundingSourceIds?: string;
}

export interface PostRateActionExtractBody {
  requestId: string;
  clientId: string;
  letterTemplate: string;
  fileBucket: string;
  fileKey: string;
}

export interface ApplyRateActionOptionBody {
  requestId: string;
  optionIndex: number;
}

export interface ApplyRateActionOptionResponse {
  fundingSourceId: string;
  alreadyApplied: boolean;
}

export interface RateActionExtractRequestSummary {
  requestId: string;
  status: 'processing' | 'completed' | 'error' | 'applied';
  letterTemplate: string;
  carrier: string | null;
  policyFormCode: string | null;
  percentageIncrease: number | null;
  createdDateTime: string | null;
  responseDateTime: string | null;
}

export const rateActionApi = {
  getPresignedUrl: (clientId: string, originalFileName: string) =>
    WaterlilyClient.post<RateActionPresignedUrlResponse>(`/client/${clientId}/presigned-url`, {
      clientId,
      originalFileName,
    }),

  startExtract: (body: PostRateActionExtractBody) =>
    WaterlilyClient.post<{ success: boolean }>('/rate-action-extract', body),

  getExtractedData: (requestId: string) =>
    WaterlilyClient.get<RateActionExtractResponse>(
      `/rate-action-extracted-data/${requestId}`,
    ),

  applyOption: (body: ApplyRateActionOptionBody) =>
    WaterlilyClient.post<ApplyRateActionOptionResponse>('/apply-rate-action-option', body),

  listRequests: (clientId: string) =>
    WaterlilyClient.get<RateActionExtractRequestSummary[]>(
      `/client/${clientId}/rate-action-extract-requests`,
    ),
};
